import React from "react";
import moment from "moment";
import { CModal, CModalBody, CModalHeader, CModalTitle } from "@coreui/react";
import { Image } from "react-bootstrap";
import corssIcon from "../../../assets/images/cross-icon-custom.png";

const TrackingActivityModal = (props) => {
  const ticketActivities = props?.erssDetails?.erssTicketActivities;

  return (
    <div className="map-activity-overlay">
      <CModal
        className="activity-modal"
        backdrop="static"
        visible={props.isActivityOpen}
        onClose={() => {
          props.setIsActivityOpen(false);
        }}
        alignment="center"
      >
        <CModalHeader closeButton={false}>
          <CModalTitle>Activity Details</CModalTitle>
          <button
            className="custom-close-btn"
            onClick={() => props.setIsActivityOpen(false)}
          >
            <Image src={corssIcon} alt="material-symbols-info-icon" />
          </button>
        </CModalHeader>
        <CModalBody>
          <div className="map-activity-body">
            <div className="ticket_activity_wrapper">
              {ticketActivities.length > 0 ? (
                ticketActivities.map((item, index) => {
                  const formattedTime = moment(
                    item?.createdAt,
                    "YYYY-MM-DD HH:mm:ss",
                  ).format("h:mm A");

                  const formattedDate = moment(
                    item?.createdAt,
                    "YYYY-MM-DD HH:mm:ss",
                  ).format("DD MMM YYYY");

                  return (
                    <div
                      className="time-slots-activity-timeliene"
                      style={{ position: "relative" }}
                      key={index}
                    >
                      <ul className="timeline-activity-card ">
                        <li className="timeline-card-item">
                          <div className="timeline--item-header liveMap-activity-timeline-header">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-calendar3"
                              viewBox="0 0 16 16"
                            >
                              <path d="M14 0H2a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V2a2 2 0 00-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z"></path>
                              <path d="M6.5 7a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2zm-9 3a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2zm-9 3a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2z"></path>
                            </svg>{" "}
                            {formattedDate}
                          </div>
                          <div className="timeline--items--content">
                            <div
                              className="timelien--activity-pils"
                              style={{ width: "100%" }}
                            >
                              <div
                                className="pils--bar"
                                style={{ width: "100%" }}
                              >
                                <div style={{ fontSize: "10px" }}>
                                  {`${formattedTime} ${item?.createdByName}`}:{" "}
                                  <span
                                    style={{
                                      color: "#5a6181c9",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {item?.message}
                                  </span>{" "}
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  );
                })
              ) : (
                <div className="p-3 " style={{ position: "relative" }}>
                  <div className="timeline-activity-card text-center">
                    No Ticket Activity
                  </div>
                </div>
              )}
            </div>
          </div>
        </CModalBody>
      </CModal>
    </div>
  );
};

export default TrackingActivityModal;
